import { browserService } from "widgets-module/services/browser.service";
import { deviceService } from "widgets-module/services/device.service";

import { AccessibilityComponent } from "./components/accessibility/accessibility.component";
import { HomeSlickComponent } from "./components/homeslick.component";
import { NotificationService } from "./components/notification/notification.service";
import { PageRatingComponent } from "./components/page-rating/page-rating.component";
import { SearchPageComponent } from "./components/search-page/search-page.component";

class WidgetsModule {
    public init(): void {
        browserService.init();
        deviceService.init();

        $.extend($, {
            pcg: {
                widgets: {
                    accessibilityComponent: new AccessibilityComponent(),
                    homeSlickComponent: HomeSlickComponent,
                    pageRatingComponent: new PageRatingComponent(),
                    searchPageComponent: new SearchPageComponent(),
                    notificationService: new NotificationService()
                }
            }
        });
    }
}

const widgets = new WidgetsModule();

$(() => widgets.init());
